import { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { B2C } from 'cosmos-components';

import { SciPage } from 'src/components/shared/SciPage';
import {
    setCarouselDotsCurrentPage,
    setCarouselPageIsCompletedAction,
} from 'src/components/shared/SciPage/SciPage.duck';
import { SciPagesEnum } from 'src/components/shared/SciPage/types';
import { sciContentKeys } from 'src/constants';
import { useSciContent } from 'src/hooks/useSciContent';

import * as S from '../shared/products.style';
import { ProductsForm } from '../shared/products.form';

import msg from './messages';
import { MODULE_PREFIX } from './extras.constants';

export const componentVehicleProtections = `${MODULE_PREFIX}-component`;

export const ExtrasComponent: FC = () => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const title = intl.formatMessage(msg.formHeaderItems.title);

    useEffect(() => {
        dispatch(setCarouselDotsCurrentPage(SciPagesEnum.Extras));
    }, [dispatch]);

    const { data: sciExtrasPageLabel, isLoading: isSciExtrasPageLoading } =
        useSciContent(sciContentKeys.sciExtrasPage);

    return (
        <SciPage data-test-id={componentVehicleProtections}>
            <S.Container>
                <S.Header>
                    <S.Title>{title}</S.Title>
                    <S.Text>
                        <B2C.LoaderContainer
                            loading={isSciExtrasPageLoading}
                            size={'small'}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: sciExtrasPageLabel ?? '',
                                }}
                            ></span>
                        </B2C.LoaderContainer>
                    </S.Text>
                </S.Header>
                <ProductsForm
                    category="Extras"
                    successCallback={() => {
                        dispatch(
                            setCarouselPageIsCompletedAction({
                                page: SciPagesEnum.Extras,
                            }),
                        );
                    }}
                />
            </S.Container>
        </SciPage>
    );
};
